import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DevicesIcon from "@mui/icons-material/Devices";
import EditDevice from "./EditDevice";
import "./ViewDevice.css";
import Tooltip from "@mui/material/Tooltip";


const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewAdminDevices = () => {
  const [devices, setDevices] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deviceToEdit, setDeviceToEdit] = useState(null);
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);
  const [paramOpen, setParamOpen] = useState(false);
  const [deviceParams, setDeviceParams] = useState([]);
  const [selectedDeviceName, setSelectedDeviceName] = useState("");

  // Add these inside your ViewSites component
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // Add these handlers below your state definitions
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await axios({
          url: `${API_URL}/api/get_customer_sites_admin/${customerId}/`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
             "X-User-Type": "A",   // ✅ ADD THIS
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {}, // 🔥 IMPORTANT: forces Content-Type header
        });

        const siteData = response.data.data;
        setSites(siteData);
        if (siteData.length > 0) {
          setSelectedSite(siteData[0].asset_id);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    if (customerId) fetchSites();
  }, [customerId, token]);

  useEffect(() => {
    const fetchDevices = async () => {
      if (!selectedSite) return;

      try {
        const response = await axios({
          url: `${API_URL}/api/get_site_devices_admin/${selectedSite}/`,
          
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
             "X-User-Type": "A",   // ✅ ADD THIS
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        });

        const deviceList = response.data.devices;

        // 🔥 Fetch attributes for each device
        const updatedDevices = await Promise.all(
          deviceList.map(async (device, index) => {
            try {
              const attrRes = await axios({
                url: `${API_URL}/api/get_device_attributes_admin/${device.device_id}/`,
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                   "X-User-Type": "A",   // ✅ ADD THIS
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                data: {},
              });

              const attributes = attrRes.data.attributes;

              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              // ✅ Extract values
              attributes.forEach((attr) => {
                if (attr.key === "latitude") latitude = attr.value;
                if (attr.key === "longitude") longitude = attr.value;
                if (attr.key === "active") is_enabled = attr.value; // 🔥 FIXED
              });

              return {
                ...device,
                id: index + 1,
                latitude,
                longitude,
                is_enabled,
              };
            } catch (err) {
              console.error(
                `Error fetching attributes for ${device.device_id}`,
                err,
              );

              return {
                ...device,
                id: index + 1,
                latitude: "-",
                longitude: "-",
                is_enabled: false,
              };
            }
          }),
        );

        setDevices(updatedDevices);
      } catch (error) {
        console.error("Error fetching devices:", error);
        setDevices([]);
      }
    };

    fetchDevices();
  }, [selectedSite, token]);

  const handleEditClick = (device) => {
    setDeviceToEdit(device);
    setEditOpen(true);
  };

  const handleSaveEdit = (updatedDevice) => {
    // Map through devices and replace the one with the matching ID
    setDevices(
      devices.map((d) => (d.id === updatedDevice.id ? updatedDevice : d)),
    );
    setEditOpen(false);
  };

  const handleDeleteClick = (device) => {
    setDeviceToDelete(device);
    setDeleteOpen(true);
    setDeleteMessage("");
    setDeleteError(false);
  };

  const handleConfirmDelete = async () => {
    if (!deviceToDelete) return;

    try {
      const response = await axios({
        url: `${API_URL}/api/delete_device/${deviceToDelete.device_id}/`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      // ✅ Success
      const msg = response.data.message || "Device deleted successfully!";
      setDeleteMessage(msg);
      setDeleteError(false);

      // Optional toast
      // toast.success(msg);

      setTimeout(() => {
        setDevices(devices.filter((d) => d.id !== deviceToDelete.id));
        setDeleteOpen(false);
        setDeleteMessage("");
      }, 1500);
    } catch (error) {
      console.error("Error deleting device:", error);

      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to delete device.";

      setDeleteMessage(backendMessage);
      setDeleteError(true);

      // toast.error(backendMessage);
    }
  };
  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };



  const handleViewParameters = async (device) => {
  try {
    const response = await axios({
      url: `${API_URL}/api/get_device_parameters_admin/${device.device_id}/`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
         "X-User-Type": "A",   // ✅ ADD THIS
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {},
    });

    setDeviceParams(response.data.parameters);
    setSelectedDeviceName(device.device_name);
    setParamOpen(true);

  } catch (error) {
    console.error("Error fetching parameters:", error);
  }
};




  return (
    <Box className="view-devices-container">
      <FormControl className="site-select-container" fullWidth sx={{ mb: 2 }}>
        <InputLabel>Select Site</InputLabel>
        <Select
          value={selectedSite}
          label="Select Site"
          onChange={(e) => setSelectedSite(e.target.value)}
        >
          {sites.map((site) => (
            <MenuItem key={site.site_id} value={site.asset_id}>
              {site.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableContainer component={Paper} className="device-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Device Name</TableCell>

              <TableCell>Latitude</TableCell>
              <TableCell>Longitude</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {devices
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((device, index) => (
                <TableRow key={device.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {device.device_name}
                    </Box>
                  </TableCell>

                  {/* <TableCell>{device.device_id}</TableCell> */}

                  <TableCell>{device.latitude}</TableCell>
                  <TableCell>{device.longitude}</TableCell>

                  <TableCell>
                    <span
                      style={{
                        color: device.is_enabled ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {device.is_enabled ? "Acive" : "Inactive"}
                    </span>
                  </TableCell>
                 <TableCell align="center">
  <Tooltip title="View Parameters">
    <IconButton
      color="info"
      onClick={() => handleViewParameters(device)}
    >
      <DevicesIcon />
    </IconButton>
  </Tooltip>
</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* Add this block after </Table> */}
        <div className="pagination-bar">
          <div className="rows-select">
            Rows per page:
            <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
            </select>
          </div>
          <div className="page-info">
            {devices.length > 0 ? page * rowsPerPage + 1 : 0}-
            {Math.min((page + 1) * rowsPerPage, devices.length)} of{" "}
            {devices.length}
          </div>
          <div className="page-arrows">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>
              ‹
            </button>
            <button
              disabled={(page + 1) * rowsPerPage >= devices.length}
              onClick={() => setPage(page + 1)}
            >
              ›
            </button>
          </div>
        </div>
      </TableContainer>

      <EditDevice
        open={editOpen}
        onClose={() => setEditOpen(false)}
        device={deviceToEdit}
        onSave={handleSaveEdit}
      />

      {/* Delete Dialog */}
      <Dialog open={deleteOpen} onClose={handleCancelDelete}>
        <DialogTitle>Delete Device</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {!deleteMessage && "Are you sure to delete this device?"}
          </DialogContentText>

          {/* ✅ Backend Message */}
          {deleteMessage && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
                color: deleteError ? "#d32f2f" : "#2e7d32",
                fontWeight: 500,
              }}
            >
              {deleteMessage}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          {/* ❌ Error → Only OK */}
          {deleteError && deleteMessage ? (
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : deleteMessage && !deleteError ? (
            /* ✅ Success → Done */
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="success"
            >
              Done
            </Button>
          ) : (
            /* 🟢 Default → Cancel + Delete */
            <>
              <Button onClick={handleCancelDelete} variant="outlined">
                Cancel
              </Button>

              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
              >
                Delete
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>


      <Dialog open={paramOpen} onClose={() => setParamOpen(false)} maxWidth="sm" fullWidth>
  <DialogTitle>
    Device Parameters - {selectedDeviceName}
  </DialogTitle>

 <DialogContent>
  {deviceParams.length === 0 ? (
    <DialogContentText>No parameters found.</DialogContentText>
  ) : (
    <>
      {/* 🔹 Header Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 2,
          pb: 1,
          borderBottom: "1px solid #ddd",
          fontWeight: "bold",
          color: "#555",
        }}
      >
        <span>Display Name</span>
        <span>Key Name</span>
      </Box>

      {/* 🔹 Data List */}
      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        {deviceParams.map((param, index) => (
          <Box
            key={index}
            sx={{
              p: 2,
              borderRadius: 2,
              boxShadow: 2,
              background: "#f9fafc",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Display Name */}
            <span style={{ fontWeight: "600" }}>
              {param.display_name}
            </span>

            {/* Key Name */}
            <span style={{ fontWeight: "600", color: "#333" }}>
              {param.key_name}
            </span>
          </Box>
        ))}
      </Box>
    </>
  )}
</DialogContent>

  <DialogActions>
    <Button onClick={() => setParamOpen(false)} variant="contained">
      Close
    </Button>
  </DialogActions>
</Dialog>


    </Box>
  );
};

export default ViewAdminDevices;
